import clsx from "classnames";
import { useLocale } from "@/hooks/useLocale";
import { Card } from "react-bootstrap";
import { useLink } from "@/hooks/useLink";
import Calendar from "@/assets/Calendar.svg";
import Location from "@/assets/Location.svg";
import { format } from "date-fns";
import classes from "./styles.module.scss";

export default function SimilarEventCard({ className, event }) {
  const link = useLink();
  const locale = useLocale();
  const [postcode, city] = event.location.split(",").reverse();

  return (
    <Card className={clsx(className, classes.card)}>
      <a href={link("events.item", event.url_slug)}>
        <Card.Img src={event[`image_${locale}`]} />
      </a>
      <Card.Body className="p-3 pb-2 bg-light">
        <Card.Title>
          <a className="text-secondary" href={link("events.item", event.url_slug)}>
            {event[`title_${locale}`]}
          </a>
        </Card.Title>
        <div className="flex-grow-1">
          <dl>
            <dt>
              <Calendar />
            </dt>
            <dd>{format(new Date(event.date), "MMM dd yyyy")}</dd>
          </dl>
          <dl>
            <dt>
              <Location />
            </dt>
            <dd>{`${postcode}, ${city}`}</dd>
          </dl>
        </div>
      </Card.Body>
    </Card>
  );
}
